/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { CEFR_LEVELS } from '../challenges/enums/cefr-level';
import { CHALLENGE_TYPES } from '../challenges/enums/challenge-type';
import { FREQUENCY_BANDS } from '../challenges/enums/frequency-band';

type ICefrSource = `auto:cefrLevel:${(typeof CEFR_LEVELS)[number]}`;
type IChallengeTypeSource = `auto:type:${(typeof CHALLENGE_TYPES)[number]}`;
type IFrequencySource = `auto:frequencyBand:${(typeof FREQUENCY_BANDS)[number]}`;

export type ICollectionSource = ICefrSource | IChallengeTypeSource | IFrequencySource;

export const COLLECTION_SOURCES: [ICollectionSource, ...ICollectionSource[]] = [
  ...CEFR_LEVELS.map((v): ICefrSource => `auto:cefrLevel:${v}`),
  ...CHALLENGE_TYPES.map((v): IChallengeTypeSource => `auto:type:${v}`),
  ...FREQUENCY_BANDS.map((v): IFrequencySource => `auto:frequencyBand:${v}`),
] as [ICollectionSource, ...ICollectionSource[]];

export const collectionSourceSchema = z.enum(COLLECTION_SOURCES);
